import apiClient from '@/services/api';

export interface ModuleTemplateDatum {
    id: string;
    title: string;
    slug: string;
    description?: string | null;
    icon: string;
    route: string;
    order_no: number;
    is_cohort_specific: boolean;
    cohort_notes?: string | null;
    is_active: boolean;
    created_by?: string | null;
    created_at: string;
    updated_at: string;
}

export interface ModuleTemplateListData {
    data: ModuleTemplateDatum[];
    total: number;
    page?: number;
    limit?: number;
    totalPages?: number;
}

export interface ModuleTemplateListRes {
    status: number;
    error: boolean;
    message: string;
    data: ModuleTemplateListData;
}

export interface GetModuleTemplateRes {
    status: number;
    error: boolean;
    message: string;
    data: ModuleTemplateDatum;
}

export interface CreateModuleTemplatePayload {
    title: string;
    slug: string;
    description?: string;
    icon?: string;
    route: string;
    order_no?: number;
    is_cohort_specific?: boolean;
    cohort_notes?: string;
    is_active?: boolean;
}

export interface UpdateModuleTemplatePayload {
    title?: string;
    slug?: string;
    description?: string;
    icon?: string;
    route?: string;
    order_no?: number;
    is_cohort_specific?: boolean;
    cohort_notes?: string;
    is_active?: boolean;
}

const moduleTemplatesService = {
    getModuleTemplates: async (
        page = 1,
        limit = 20,
        search?: string,
        isActive?: boolean,
        isCohortSpecific?: boolean,
        all?: boolean,
    ): Promise<ModuleTemplateListRes> => {
        const res = await apiClient.get<ModuleTemplateListRes>('/module-templates', {
            params: {
                page,
                limit,
                ...(search && search.trim() !== '' ? { search: search.trim() } : {}),
                ...(isActive !== undefined ? { is_active: isActive } : {}),
                ...(isCohortSpecific !== undefined ? { is_cohort_specific: isCohortSpecific } : {}),
                ...(all !== undefined ? { all } : {}),
            },
        });
        return res.data;
    },

    getModuleTemplate: async (id: string): Promise<GetModuleTemplateRes> => {
        const res = await apiClient.get<GetModuleTemplateRes>(`/module-templates/${id}`);
        return res.data;
    },

    createModuleTemplate: async (
        payload: CreateModuleTemplatePayload,
    ): Promise<GetModuleTemplateRes> => {
        const res = await apiClient.post<GetModuleTemplateRes>('/module-templates', payload);
        return res.data;
    },

    updateModuleTemplate: async (
        id: string,
        payload: UpdateModuleTemplatePayload,
    ): Promise<GetModuleTemplateRes> => {
        const res = await apiClient.patch<GetModuleTemplateRes>(`/module-templates/${id}`, payload);
        return res.data;
    },

    deleteModuleTemplate: async (id: string): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/module-templates/${id}`);
        return res.data;
    },
};

export default moduleTemplatesService;
